const IS_DEBUG = false;
export const BACKGROUND_COLOR = {
  row: IS_DEBUG ? 'rgba(255,0,0,0.05)' : 'transparent',
  col: IS_DEBUG ? 'rgba(0,255,0,0.05)' : 'transparent',
  container: IS_DEBUG ? 'rgba(0,0,255,0.05)' : 'transparent',
};

